import axios from 'axios';

const API_URL = '/api/mac-whitelist';

// 获取MAC地址白名单列表
export const getMacWhitelist = async (page = 1, limit = 10, applicationId = '', search = '', activated = '') => {
  try {
    const response = await axios.get(API_URL, {
      params: { page, limit, applicationId, search, activated }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '获取MAC地址白名单失败' };
  }
};

// 添加MAC地址到白名单（支持单个或批量）
export const addMacAddress = async (macAddresses, applicationId, description = '') => {
  try {
    // 如果传入的是字符串，转换为数组（向后兼容）
    const macList = Array.isArray(macAddresses) ? macAddresses : [macAddresses];
    
    const response = await axios.post(API_URL, {
      macAddresses: macList,
      applicationId,
      description
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '添加MAC地址失败' };
  }
};

// 删除MAC地址
export const deleteMacAddress = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '删除MAC地址失败' };
  }
};

// 获取MAC地址详情
export const getMacAddressById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '获取MAC地址详情失败' };
  }
};

// 获取应用列表（用于下拉选择）
export const fetchApplications = async () => {
  try {
    const response = await axios.get('/api/applications');
    return response.data.applications;
  } catch (error) {
    throw error.response?.data || { message: '获取应用列表失败' };
  }
};

